module.exports = __webpack_public_path__ + "static/media/icon_talk_attention.80e62576.svg";